import React, { useState } from 'react';
import TabSelector from '../components/TabSelector';
import { addQuoteImageAction } from '../reduxstore/actions/quoteActions';
import { useDispatch } from 'react-redux';
import Sidebar from '../components/Sidebar';
import GetQuoteReviewScreen from '../screens/GetQuoteReviewScreen';
import DefaultModal from '../components/modals/DefaultModal';

const options = [
  { id: 'drop_files', label: 'Drop files' },
  { id: 'review_quote', label: 'Review' },
  { id: 'submit_quote', label: 'Submit' },
];

const GetQuotePage = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(true);
  const [currentTab, setCurrentTab] = useState('drop_files');
  const handleTabChange = (tab) => {
    setCurrentTab(tab);
  };

  // Method to handle file upload
  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const fileData = reader.result;

      // Store the file data in redux state (for now)
      dispatch(addQuoteImageAction(fileData));

      // Update the state to navigate to the review section
      setCurrentTab('review_quote');
    };
  };

  const getSubmissionPopup = () => {
    return (
      <div>
        <GetQuoteReviewScreen />
        {showModal && (
          <DefaultModal
            heading="Congratulations!"
            MainData="Your Quote 12345 has been Successfully submitted"
            SecondaryData="We will get back to you in 24 hours."
            ReturnTitle="Return to Dashboard"
            ButtonTitle="Dashboard"
            ButtonLink="/dashboard?tab=my_quotes"
          />
        )}
      </div>
    );
  };

  const uploadFileButton = () => {
    return (
      <div className="flex items-center">
        <label
          htmlFor="dropzone-file"
          className="flex flex-col items-center justify-center w-3/12 h-64 border-base-black border-width-1 border rounded-lg cursor-pointer bg-transparent dark:border-gray-600 ml-4"
        >
          <div className="flex flex-col items-center justify-center pt-3 pb-4">
            <svg
              className="w-6 h-6 mb-2 text-gray-500 dark:text-gray-400"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 16"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
              />
            </svg>
            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
              Drag and Drop | <span className="font-semibold">Upload File</span>{' '}
            </p>
          </div>
          <input
            id="dropzone-file"
            type="file"
            className="hidden"
            onChange={handleFileUpload}
          />
        </label>
      </div>
    );
  };

  const getCurrentSection = () => {
    if (currentTab === 'drop_files') {
      return uploadFileButton();
    } else if (currentTab === 'review_quote') {
      return <GetQuoteReviewScreen handleTabChange={handleTabChange} />;
    } else if (currentTab === 'submit_quote') {
      return getSubmissionPopup();
    }
  };

  return (
    <div className="flex flex-row">
      <div className="self-stretch">
        <Sidebar />
      </div>

      <div className="flex flex-col flex-grow px-10">
        <TabSelector
          options={options}
          handleTabChange={handleTabChange}
          currentTab={currentTab}
        />

        <div className="mt-5">{getCurrentSection()}</div>
      </div>
    </div>
  );
};

export default GetQuotePage;
